var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { TextComponent, KRWFomatToString, StyledDivider } from 'renderer/components';
import Row from 'antd/lib/row';
import { PaymentHistoryQuery, ManagerQuery, ProductQuery } from 'renderer/queries';
import Radio from 'antd/lib/radio';
import styled from 'styled-components';
import Select from 'antd/lib/select';
import * as dayjs from 'dayjs';
import { Cell, LabelList, Pie, PieChart } from 'recharts';
import { COLORS } from 'renderer/styles';
import { floor, groupBy, orderBy, sum, isEmpty, getRanges, useWindowSize } from 'renderer/utils';
import { CHART_PALLETE } from 'renderer/constants';
import Empty from 'antd/lib/empty';
import Col from 'antd/lib/col';
import DatePicker from 'antd/lib/date-picker';
export var StatUsing = function (props) {
    var _a, _b, _c, _d;
    var storeId = (_a = props.store) === null || _a === void 0 ? void 0 : _a.id;
    var today = dayjs();
    var managers = ManagerQuery.getWorkingManagersInCache();
    var _e = React.useState({
        startedAt: today.startOf('day').toDate(),
        endedAt: today.endOf('day').toDate(),
        managerId: props.readAll ? 'all' : (_b = props.loginManager) === null || _b === void 0 ? void 0 : _b.id
    }), values = _e[0], setValues = _e[1];
    var stat = PaymentHistoryQuery.useUsingStatistics({
        storeId: storeId,
        startedAt: values.startedAt,
        endedAt: values.endedAt,
        managerId: values.managerId === 'all' ? undefined : values.managerId
    }, { enabled: !!storeId });
    var handleChange = function (values) {
        setValues(values);
    };
    var products = ProductQuery.useProducts({ storeId: storeId, paranoid: false }, { enabled: !!storeId });
    var allUsingTotalSales = sum((_c = stat.data) === null || _c === void 0 ? void 0 : _c.map(function (using) { return using.price; })) || 0;
    var getData = function () {
        var groupedByProduct = groupBy(stat.data, 'productId');
        return orderBy(Object.keys(groupedByProduct).map(function (productId) {
            var _a, _b;
            var product = (_b = (_a = products.data) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.id === Number(productId); });
            var usings = groupedByProduct[productId];
            var name = (product === null || product === void 0 ? void 0 : product.nameWithGroupName) || '삭제된 상품';
            var amountOfUsing = usings.length;
            var totalPrice = sum(usings.map(function (using) { return using.price || 0; }));
            var percentage = floor((totalPrice / allUsingTotalSales) * 100, 1);
            return { productId: usings[0].productId, name: name, amountOfUsing: amountOfUsing, totalPrice: totalPrice, percentage: percentage, allUsingTotalSales: allUsingTotalSales };
        }), 'totalPrice', 'asc');
    };
    var data = getData();
    var selecteManagerName = ((_d = (managers || []).filter(Boolean).find(function (manager) { return manager.id === (values === null || values === void 0 ? void 0 : values.managerId); })) === null || _d === void 0 ? void 0 : _d.displayName) || '전체';
    var isEmptyData = isEmpty(data) || allUsingTotalSales === 0;
    return (React.createElement("div", null,
        React.createElement(StatisticRemoteController, { managers: props.readAll ? managers : [props.loginManager], readAll: props.readAll, durationSelector: true, storeId: storeId, onChange: handleChange, values: values }),
        React.createElement(ChartWrapper, null,
            React.createElement(TextComponent, { type: "headline2", marginBottom: 44, textAlign: "center" },
                dayjs(values.startedAt).format('YYYY년 MM월 DD일'),
                " ~ ",
                dayjs(values.endedAt).format('YYYY년 MM월 DD일'),
                " (",
                selecteManagerName,
                ")"),
            isEmptyData ? (React.createElement(Empty, null)) : (React.createElement(Row, { gutter: 16, align: "middle", justify: "space-around" }, data && (React.createElement(Col, { span: 12 },
                __spreadArray([], data, true).reverse().map(function (item, index) {
                    return (React.createElement(LegendItem, { key: item.productId, label: item.name, amount: item.amountOfUsing, total: item.totalPrice, color: CHART_PALLETE[data.length - 1 - index], order: index + 1 }));
                }),
                React.createElement(Row, { justify: "end" },
                    React.createElement(TextComponent, { type: "subtitle2", color: COLORS.gray1, marginTop: 16, children: "\uC774\uC6A9\uB8CC \uD569\uACC4 ".concat(KRWFomatToString({ value: allUsingTotalSales })) })))))))));
};
export var StatisticRemoteController = function (props) {
    var isPC = useWindowSize().isPC;
    var durationSelector = props.durationSelector, intervalSelector = props.intervalSelector, _a = props.rangepicker, rangepicker = _a === void 0 ? true : _a, storeId = props.storeId;
    var today = dayjs();
    var handleDurationChange = function (event) {
        var value = event.target.value;
        if (value === 'today') {
            handleChange('dates', [today, today]);
        }
        else if (value === 'yesterday') {
            var yesterday = today.subtract(1, 'day');
            handleChange('dates', [yesterday, yesterday]);
        }
        else if (value === 'weekAgo') {
            handleChange('dates', [today.subtract(1, 'week'), today]);
        }
        else if (value === 'monthAgo') {
            handleChange('dates', [today.subtract(1, 'month'), today]);
        }
    };
    var handleChange = function (name, value) {
        var newValues = __assign({}, props.values);
        if (name === 'dates') {
            if (!value) {
                return;
            }
            newValues = __assign(__assign({}, newValues), { startedAt: value[0].startOf('day').toDate(), endedAt: value[1].endOf('day').toDate() });
        }
        else if (name === 'all') {
            newValues = __assign(__assign(__assign({}, newValues), value), { startedat: dayjs(values.startedAt).startOf('day').toDate(), endedAt: dayjs(values.endedAt).endOf('day').toDate() });
        }
        else {
            newValues[name] = value;
        }
        // if (dayjs(newValues.endedAt).diff(newValues.startedAt, 'day') >= 365) {
        //   // notification.info({ message: '365일 이상은 검색할 수 없습니다.' });
        // } else {
        // }
        props.onChange(newValues);
    };
    var values = props.values;
    var renderManagerSelector = function () {
        return (React.createElement(Col, null,
            React.createElement(Row, { justify: isPC ? 'end' : 'start' },
                React.createElement(StyledSelect, { value: values.managerId, onChange: function (value) { return handleChange('managerId', value); }, options: (props.readAll ? [{ label: '전체', value: 'all' }] : []).concat((props.managers || [])
                        .filter(Boolean)
                        .map(function (manager) { return ({ value: manager.id, label: manager.displayName }); })) }))));
    };
    return (React.createElement(Row, { justify: "space-between", gutter: 8 },
        React.createElement(Col, null,
            React.createElement(Row, { gutter: 8 },
                durationSelector && isPC && (React.createElement(Col, null,
                    React.createElement(StyledRadioGroup, { onChange: handleDurationChange, defaultValue: "today" },
                        React.createElement(Radio.Button, { value: "today" }, "\uC624\uB298"),
                        React.createElement(Radio.Button, { value: "yesterday" }, "\uC5B4\uC81C"),
                        React.createElement(Radio.Button, { value: "weekAgo" }, "1\uC8FC\uC77C"),
                        React.createElement(Radio.Button, { value: "monthAgo" }, "1\uAC1C\uC6D4")))),
                intervalSelector && (React.createElement(Col, null,
                    React.createElement(StyledRadioGroup, { value: values.interval || 'day', onChange: function (event) {
                            var today = dayjs();
                            var interval = event.target.value;
                            if (interval === 'year') {
                                handleChange('all', __assign(__assign({}, props.values), { startedAt: today.subtract(2, 'year').startOf('day').toDate(), endedAt: today.toDate(), interval: interval }));
                            }
                            else if (interval === 'month') {
                                handleChange('all', __assign(__assign({}, props.values), { startedAt: today.subtract(12, 'month').startOf('day').toDate(), endedAt: today.toDate(), interval: interval }));
                            }
                            else if (interval === 'day') {
                                handleChange('all', __assign(__assign({}, props.values), { startedAt: today.subtract(30, 'day').startOf('day').toDate(), endedAt: today.toDate(), interval: interval }));
                            }
                        } },
                        React.createElement(Radio.Button, { value: "day" }, "\uC77C\uAC04"),
                        React.createElement(Radio.Button, { value: "month" }, "\uC6D4\uAC04"),
                        React.createElement(Radio.Button, { value: "year" }, "\uC5F0\uAC04")))),
                rangepicker && (React.createElement(DatePicker.RangePicker, { onChange: function (values) { return handleChange('dates', values); }, value: [dayjs(values.startedAt), dayjs(values.endedAt)], placeholder: ['시작 날짜', '끝 날짜'], ranges: getRanges(today) })))),
        renderManagerSelector()));
};
export var LegendItem = function (props) {
    return (React.createElement("div", null,
        React.createElement(Row, { style: { width: '100%' }, align: "middle", justify: "space-between" },
            React.createElement(Col, null,
                React.createElement(Row, { align: "middle" },
                    React.createElement(TextComponent, { type: "subtitle1", color: COLORS.gray1, marginRight: 20 },
                        props.order,
                        "."),
                    React.createElement(ColorCircle, { color: props.color }),
                    React.createElement(TextComponent, { type: "body2", color: COLORS.gray2, marginLeft: 8, ellipsis: true }, props.label))),
            React.createElement(TextComponent, { type: "body2", color: COLORS.gray2 }, KRWFomatToString({ value: props.total }))),
        React.createElement(StyledDivider, { marginTop: 10, marginBottom: 10 })));
};
export var CustomedPieChart = function (props) {
    var _a;
    var data = props.data;
    var colors = props.colors || CHART_PALLETE;
    var totalWithNegative = sum((_a = props.data) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (item.total < 0 ? -item.total : item.total || 0); }));
    var newItems = data === null || data === void 0 ? void 0 : data.map(function (item) {
        var isNegative = item.total < 0;
        var total = isNegative ? -item.total : item.total;
        return __assign(__assign({}, item), { total: total, percentage: floor((total / totalWithNegative) * 100, 1), isNegative: isNegative, totalPaidPriceWithUnpaid: totalWithNegative });
    });
    return (React.createElement(PieChart, { width: props.width, height: props.height },
        React.createElement(Pie, { isAnimationActive: false, data: newItems, innerRadius: "55%", paddingAngle: 0, startAngle: 90, endAngle: -270, dataKey: "percentage", labelLine: false },
            newItems.map(function (entry, index) {
                return (React.createElement(Cell, { key: "cell-".concat(index), stroke: colors[index], strokeDasharray: entry.isNegative ? 3 : null, fill: entry.isNegative ? 'white' : colors[index] }));
            }),
            data.map(function (entry, index) {
                return (React.createElement(StyledLabelList, { key: "label-".concat(index), position: 'outside', offset: 5, formatter: function (value) {
                        return value ? (value >= 10 ? "".concat(value, "%") : '') : '';
                    }, text: "100%", fill: COLORS.gray2, stroke: "none" }));
            }))));
};
var StyledLabelList = LabelList;
export var FixedCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 300px;\n"], ["\n  width: 300px;\n"])));
export var ColorCircle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "px;\n  height ", "px;\n  background-color: ", ";\n  border-radius: 50%;\n"], ["\n  width: ", "px;\n  height ", "px;\n  background-color: ", ";\n  border-radius: 50%;\n"])), function (props) { return props.width || 15; }, function (props) { return props.width || 15; }, function (props) { return props.color; });
export var StyledRadioGroup = styled(Radio.Group)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  & > label {\n    // width: 60px;\n    // padding: 5px 15px;\n  }\n"], ["\n  & > label {\n    // width: 60px;\n    // padding: 5px 15px;\n  }\n"])));
export var StyledSelect = styled(Select)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100px;\n"], ["\n  width: 100px;\n"])));
export var ChartWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 36px 34px 50px 32px;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n  background-color: var(--white);\n  margin-top: 20px;\n  min-height: 520px;\n"], ["\n  padding: 36px 34px 50px 32px;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n  background-color: var(--white);\n  margin-top: 20px;\n  min-height: 520px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
